import { useBrowser } from '@s4l/utils/hooks/useBrowser'
import { isRTL } from '@s4l/utils/library/rtl'
import React from 'react'
import { Drawer } from 'vaul'
import type { BottomSheetContentRef } from './Content'
import { Content } from './Content'
import { Trigger } from './Trigger'

export type { BottomSheetContentRef }

type BottomSheetProps = React.ComponentProps<typeof Drawer.Root> & {
  shouldScaleBackground?: boolean
  onOpenChange?: (open: boolean) => void
}

const BottomSheet = ({
  shouldScaleBackground = true,
  onOpenChange,
  direction,
  ...props
}: BottomSheetProps) => {
  const { isAppleDevice } = useBrowser()

  function onOpenChangeInternal(open: boolean) {
    onOpenChange?.(open)

    let prefix = 'dvh'
    if (isAppleDevice) {
      prefix = 'svh'
      document.body.style.setProperty('scroll-behavior', 'auto', 'important')
      document.documentElement.style.setProperty('scroll-behavior', 'auto', 'important')
    }

    // wait for the drawer to be mounted
    requestAnimationFrame(() => {
      const drawers = document.querySelectorAll<HTMLDialogElement>('[data-vaul-drawer]')
      const drawer = [...drawers].at(-1)

      if (drawer) {
        // wait for the drawer to be styled
        const drawerHeight = getComputedStyle(drawer).height
        drawer.style.top = `calc(100${prefix} - ${drawerHeight})`
      }
    })
  }

  let directionNormalized = direction

  if (direction === 'right' && isRTL()) {
    directionNormalized = 'left'
  }

  return (
    <Drawer.Root
      onOpenChange={onOpenChangeInternal}
      shouldScaleBackground={shouldScaleBackground}
      disablePreventScroll={false}
      repositionInputs={false}
      direction={directionNormalized}
      {...props}
    />
  )
}

BottomSheet.Trigger = Trigger
BottomSheet.Content = Content

export default BottomSheet
